import React from "react";
import "./index.css";

const Section = React.forwardRef((props, ref) => {
    return (
        <section ref={ref} id={props.id} className={props.className}>{props.children}</section>
    );
});

export default Section;